// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3zDtn","colMin":"styles_colMin__2KjS0","colCheckbox":"styles_colCheckbox__3LK5a"};